import {defineStore} from "pinia";
import productDocumentationDataService from "../Services/productDocumentationDataService";

export const useProductStore = defineStore('productStore', {
    state: () => ({
        search: '',
        searchResult: null,
        translations: null,
        languages: [],
        productFamilies: [],
        isLoading: 0,
        error: false,
        receivedProductFamilies: [],
        receivedLanguages: [],
        selectedType: '',
        selectedProduct: '',
        selectedLanguage: 'English (United Kingdom)',
        selectedLanguageCode: 'en-GB',
    }),

    getters: {
        productFamilies: (state) => {
            return state.receivedProductFamilies.map((product) => ({
                key: product.familyName,
                value: product.familyName,
            }));
        },
        languages: (state) => {
            return state.receivedLanguages.map((language) => ({
                key: language.englishName,
                value: language.code,
            }));
        },
    },

    actions: {
        setInitialState() {
            this.isLoading++;
            productDocumentationDataService
                .getTranslations()
                .then((response) => {
                    this.translations = response.data;
                })
                .catch(() => {
                    this.error = true;
                    console.error(this.error);
                })
                .finally(() => {
                    this.isLoading--;
                });

            this.receivedProductFamilies = productDocumentationDataService.getProductFamilies();
            this.isLoading++;
            productDocumentationDataService
                .getProductFamilies()
                .then((response) => {
                    this.receivedProductFamilies = response.data;
                })
                .catch(() => {
                    this.error = true;
                })
                .finally(() => {
                    this.isLoading--;
                });

            this.receivedLanguages = productDocumentationDataService.getLanguages();
            this.isLoading++;
            productDocumentationDataService
                .getLanguages()
                .then((response) => {
                    this.receivedLanguages = response.data;
                })
                .catch(() => {
                    this.error = true;
                })
                .finally(() => {
                    this.isLoading--;
                });
        },

        performSearch() {
            this.searchResult = productDocumentationDataService.getProductData(
                this.selectedProduct,
                this.selectedLanguageCode,
                this.selectedType,
                this.search,
            );

            this.isLoading++;
            productDocumentationDataService
                .getProductData(
                    this.selectedProduct,
                    this.selectedLanguageCode,
                    this.selectedType,
                    this.search,
                )
                .then((data) => {
                    this.searchResult = data;
                })
                .catch((error) => {
                    this.error = true;
                    this.errorMessage = error;
                    this.searchResult = null;
                })
                .finally(() => {
                    this.isLoading--;
                    this.error = false;
                });
        },

        clearFilter() {
            this.selectedType = "";
            this.selectedProduct = "";
            this.selectedLanguage = "English (United Kingdom)";
            this.selectedLanguageCode = "en-GB";
            this.search = "";
            this.searchResult = null;
        },
    },
});
